import { EnergySource } from "./energy-source";
import { Howl } from "howler"
import { Game } from "./game"

// This age variable is simply how long the player has had this energy source for.
// It should be incremented every turn.
// When the round ends, it should be checked to see if the age should equal expiration. 
// age starts at zero. 
// Should be incremented, and then checked for expiration. 

// add profit thing, and add variable to where it can be given out every n # of turns.
// math for it: increment turn timer. if age mod n is zero, give payout
interface InventoryItem {
    isBuilt: boolean;
    age: number;
    timeToBuild: number
}

export function getEnergySumOfSource(energySources: Map<EnergySource, InventoryItem[]>, sourcestr: string, sourceele?: EnergySource) {
    let source
    if (sourceele != null) {
        source = sourceele
    } else {
        source = Array.from(energySources.keys()).find((es: EnergySource) => es.name === sourcestr)!
    }
    // can force unwrap as this method will only be called if the units are not null
    const foo = energySources.get(source)
    if (foo !== undefined) {
        const valid = []
        foo.forEach((item) => item.isBuilt ? valid.push(item) : null)
        return valid.length * source.mwatts
    } else {
        return 0
    }
    
}

export function getSum(energySources: Map<EnergySource, InventoryItem[]>, sourcestr: string, sourceele?: EnergySource) {
    let source
    if (sourceele != null) {
        source = sourceele
    } else {
        source = Array.from(energySources.keys()).find((es: EnergySource) => es.name === sourcestr)!
    }
    // can force unwrap as this method will only be called if the units are not null
    const foo = energySources.get(source)
    if (foo !== undefined) {
        const valid = []
        foo.forEach((item) => item.isBuilt ? valid.push(item) : null)
        return valid.length
    } else {
        return 0
    }
    
}

export function isConstructing(energySources: Map<EnergySource, InventoryItem[]>, sourcestr: string) {
    const source = Array.from(energySources.keys()).find((es: EnergySource) => es.name === sourcestr)!
    const foo = energySources.get(source)
    if (foo != null) {
        let mostConstructed = 0
        foo.forEach((ele) => {
            if (!ele.isBuilt) {
                mostConstructed < source.timeToBuild - ele.age ? mostConstructed = ele.age - source.timeToBuild : mostConstructed = mostConstructed
            }
        })
        return mostConstructed

    } else {
        return 0
    }
}

export function getTotalEnergy(state: Game) {
    const sources = Array.from(state.inventory.energySources.keys())
    // for all sources
    let energy = 0
    sources.forEach((source: EnergySource) => {
        const units = state.inventory.energySources.get(source)
        if (units != null) {
            let loopMax = units.length
            for (let i = 0; i < loopMax; i++) {
                // Vue.set()
                units[i].age++
                if (!units[i].isBuilt && units[i].age >= source.timeToBuild) {
                    units[i].isBuilt = true
                    if (!state.muted) {
                        new Howl({
                            src: ["/audio/Construction finished.mp3"]
                        }).play()
                    }
                }
                let factor = 0
                if (source.timeToBuild === -1) { factor = 1 }
                if (units[i].isBuilt && (units[i].age - source.timeToBuild - factor) > source.expires && source.expires !== -1) {
                    units.splice(i, 1)
                    loopMax--
                    i--
                }
            }
            state.inventory.energySources.set(source, units)
            energy += getEnergySumOfSource(state.inventory.energySources, source.name, source)
        }
    })
    state.inventory.inventoryChangeNum += 1
    return energy
}

export function getProfit(state: Game) {
    const sources = Array.from(state.inventory.energySources.keys())
    let profit = 0
    sources.forEach((source: EnergySource) => {
        const units = state.inventory.energySources.get(source)
        if (units != null) {
            units.forEach((unit) => profit += (source.profitPerTurn !== -1 && unit.age % source.profitPerTurn === 0 && unit.isBuilt ? source.profitMargin : 0))
        }
    })
    state.inventory.inventoryChangeNum += 1
    return profit
}

export function getSourceProfit(state: Game, sourcestr: string) {
    const source = Array.from(state.inventory.energySources.keys()).find((es) => es.name === sourcestr)!
    let profit = 0
    const units = state.inventory.energySources.get(source)
    if (units != null) {
        units.forEach((unit) => profit += (source.profitPerTurn !== -1 && unit.age % source.profitPerTurn === 0 && unit.isBuilt ? source.profitMargin : 0))
    }
    return profit
}

export function getClimateAmt(state: Game, sourcestr: string) {
    const source = Array.from(state.inventory.energySources.keys()).find((es: EnergySource) => es.name === sourcestr)!
    const units = state.inventory.energySources.get(source)
    if (units != null) {
        return source.pollutionFactor * units.length
    } else {
        return 0
    }

}

export class Inventory {
    public energySources: Map<EnergySource, InventoryItem[]>
    public inventoryChangeNum = 0

    constructor() {
        this.energySources = new Map<EnergySource, InventoryItem[]>();
    }
}
